























































































































































































































































































































































































































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Actions, Mutations, FormModes } from '@/ts/store/Constants';
import Countries from '@/data/countries';
import DateMethods from '@/mixins/DateMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import MultiSelect from 'vue-multiselect';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import moment from 'moment';

@Component({
    components: {
        DatePicker,
        MultiSelect,
    },
})
export default class PreviewApplicationForm extends Mixins(DateMethods, InputFieldMethods, LocalizationMethods, NotifyMethods) {
    @Prop() public applicationData!: any;
    @Prop({ default: 'preview' }) public formMode: string;

    public countries = Countries;
    public educationalTagsSearch: any = '';
    public socialTagsSearch: any = '';
    public currentlyResident: boolean;
    public applicationCpr: any;

    constructor() {
        super();
    }

    get isPreview(): boolean {
        return this.formMode === FormModes.Preview;
    }

    get socialTags() {
        return this.$store.getters['Tags/getSocialTags'];
    }

    get educationalTags() {
        return this.$store.getters['Tags/getEducationalTags'];
    }

    get applicationMasterData() {
        return this.$store.getters['WaitingLists/getApplicationMasterData'];
    }

    get professionTags() {
        return this.$store.getters['Tags/getProfessionTags'];
    }

    get professionTagsOptions() {
        const professionalOptions: any = [];
        this.professionTags.forEach((tag: any) => {
            professionalOptions.push({label: tag.name, value: tag.key});
        });
        return professionalOptions;
    }

    get filteredApplicationEducationalTags() {
        const filteredApplicationEducationalTags = this.educationalTags;
        const existingTagIds = this.applicationData.education_tags.map((t: any) => t.id);
        return filteredApplicationEducationalTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.educationalTagsSearch.toLowerCase());
        });
    }

    get filteredApplicationSocialTags() {
        const filteredApplicationSocialTags = this.socialTags;
        const existingTagIds = this.applicationData.social_club_tags.map((t: any) => t.id);
        return filteredApplicationSocialTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.socialTagsSearch.toLowerCase());
        });
    }

    get corporationName() {
        return typeof this.applicationData.corporation !== 'undefined' && this.applicationData.corporation !== null
            ? this.applicationData.corporation.name
            : '';
    }

    public removeEducationalTagFromApplication(tag: any) {
        this.educationalTagsSearch = '';
        this.$store.commit(Mutations.REMOVE_EDUCATIONAL_TAG_FROM_APPLICATION, tag.id);
    }

    public masterDataOptions(key: any) {
        return (this.applicationMasterData && this.applicationMasterData[key]) ? this.applicationMasterData[key] : [];
    }

    public addEducationalTagToApplication(tag: any) {
        this.educationalTagsSearch = '';
        this.$store.commit(Mutations.ADD_EDUCATIONAL_TAG_TO_APPLICATION, tag);
    }

    public removeSocialClubTagFromApplication(tag: any) {
        this.$store.commit(Mutations.REMOVE_SOCIAL_TAG_FROM_APPLICATION, tag.id);
    }

    public addSocialClubTagToApplication(tag: any) {
        this.$store.commit(Mutations.ADD_SOCIAL_TAG_TO_APPLICATION, tag);
    }

    public previewAttachedDocument(documentId: number, originalName: string, ext: string)  {
        this.$store.commit(Mutations.SET_PREVIEWED_DOCUMENT_EXTENTION, ext);
        this.$store.commit(Mutations.SET_PREVIEWED_DOCUMENT_ORIGINAL_NAME, originalName);
        this.$store.dispatch(Actions.FETCH_PREVIEWED_DOCUMENT, documentId);
    }

    public calculateAge(birthday: string): number {
        return moment().diff(moment(birthday, 'YYYY-MM-DD'), 'years');
    }

    public getCpr(cpr: any) {
        return cpr ? cpr.split('-')[1] : '';
    }

    public getFilenameExt(name: string) {
        return name.split('.')[1];
    }

    public declineApplication(applicationId: number) {
        this.$store.dispatch(Actions.DECLINE_APPLICATION, applicationId);
    }

    public acceptApplication(applicationId: number)  {
        this.$store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
        this.$store.commit(Mutations.SET_AVAILABLE_APARTMENTS_VISIBILITY, true);
        this.$store.dispatch(Actions.FETCH_ALL_AVAILABLE_APARTMENTS, {id: applicationId, ignore: false});
    }

    public toggleApplicationActive(applicationId: number, active: string) {
        this.$store.dispatch(Actions.TOGGLE_APPLICATION_ACTIVE, {applicationId, active});
    }

    public deleteApplication(applicationId: number) {
        this.$store.dispatch(Actions.DELETE_APPLICATION, applicationId);
    }

    public editApplication() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const application = this.applicationData;

                if (!this.applicationData.projects.length) {
                    return this.notify('please_select_at_least_one_project', 'warning');
                }

                const requestData = {
                    id: application.id,
                    firstName: application.first_name,
                    lastName: application.last_name,
                    email: application.mail,
                    phone: application.phone,
                    gender: application.gender,
                    birthday: application.birthday,
                    applicationCpr: this.applicationCpr,
                    addressCountry: application.address_country,
                    addresCity: application.address_city,
                    addressStreet: application.address_street,
                    addressFloor: application.address_floor,
                    addressNumber: application.address_number,
                    addressDoor: application.address_door,
                    addressZip: application.address_zip,
                    interestedFrom: application.interested_from,
                    applicationMotivation: application.application_motivation,
                    aboutMe: application.about_me,
                    resident: this.currentlyResident,
                    professional: application.professional,
                    education: application.education_tags.map((t: any) => t.id),
                    socialClubTagIds: application.social_club_tags.map((t: any) => t.id),
                    projectsIds: application.projects.map((t: any) => t.id),
                    variantIds: application.variants.map((t: any) => t.id),
                    buildingIds: application.buildings.map((t: any) => t.id),
                };

                this.$store.dispatch(Actions.UPDATE_APPLICATION, requestData);
            }
        });
    }

    public close(): void {
        this.$store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);
        this.$store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
    }

    public beforeDestroy() {
        this.close();
    }

    public created() {
        this.currentlyResident = (this.applicationData.resident === 'on');

        const projectIds = this.applicationData.projects.map((p: any) => p.id);
        if (this.applicationData.project && !projectIds.includes(this.applicationData.project.id)) {
            this.applicationData.projects.push(this.applicationData.project);
        }

        this.applicationCpr = this.getCpr(this.applicationData.cpr);
        this.$store.dispatch(Actions.FETCH_TAGS, {type: 'demographic'});
    }
}
